import {put, call, takeLatest, select} from 'redux-saga/effects';
import reportTokenApi from '../api/reportToken.api';
import {waitFor} from '../helpers/saga.helper';
import * as ActionTypes from '../actions/types.action';
import {getBearerHeader} from '../helpers/api.helper';

function* reportToken(action) {
  try {
    const getAuth = state => state.auth;
    let storeToken = yield select(getAuth);
    const times = 5;
    const ms = 300;
    let attempts = 0;
    const maxAttempts = 5;

    while (!storeToken && attempts < maxAttempts) {
      try {
        storeToken = yield waitFor(getAuth, times, ms);
      } catch (error) {
        attempts++;
        if (attempts >= maxAttempts) {
          console.log(
            `Failed to get auth after ${maxAttempts} attempts: ${error.message}`
          );
        }
        yield delay(ms);
      }
    }
    const headers = getBearerHeader(action.jjToken, storeToken);
    let params = {access_token: storeToken.access_token};
    const results = yield call(reportTokenApi.get, params, headers);
    yield put({
      type: ActionTypes.GET_REPORT_TOKEN_SUCCESS,
      reportToken: results,
    });
  } catch (e) {
    console.log(e);
    yield put({
      type: ActionTypes.GET_REPORT_TOKEN_FAILED,
      message: e.message,
    });
  }
}

export default function* reportTokenYield() {
  yield takeLatest(ActionTypes.GET_REPORT_TOKEN_REQUESTED, reportToken);
}
